export default function UserException(message) {
  this.message = message;
  this.type = "UserException";
}

export const defaultErrorMessage =
  "Something went wrong. Please try again later.";
